import { AdjustCoinStatusPage } from './AdjustCoinStatusPage'
import { withAdjustCoinStatusPage } from './withAdjustCoinStatus'

const ConnectedAdjustCoinStatusPage =
  withAdjustCoinStatusPage(AdjustCoinStatusPage)

export { ConnectedAdjustCoinStatusPage as AdjustCoinStatusPage }
